import config from 'config';
import axios from 'axios';

export const policyService = {
  getPolicies,
  getPoliciesTable,
  getInvoicesfromPolicy,
  getInvoicesOfPoliciesTable,
  getPendingInvoices

}

async function callToAPI(url, op, data) {

  let config = {
    method: op,
    url: url,
    headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).access}`},
    'Content-Type': 'application/json',
    data: data
  };

  let response = await axios(config)
    .then((response) => {
      //console.log("Respuesta")
      //console.log (response)
      return response.data
    })
    .catch((error) => {
      let mensajeError = {}
      mensajeError.error = error
      if (error.response.status === 401) {
        //place your reentry code
        mensajeError.msg = "No está autenticado en el sistema o su usuario ha caducado"
       }
      //console.log(mensajeError)
      return mensajeError
      });

  return response
}

async function getPolicies() {
  let myPolicies = await callToAPI(`${config.apiUrl}/cartera/polizas/`, 'get', {});
  return myPolicies
}

async function getInvoicesfromPolicy(policy_id) {
  let myInvoices = await callToAPI(`${config.apiUrl}/cartera/recibos-de-poliza/${policy_id}`, 'get', {});
  return myInvoices
}


async function getPendingInvoices() {
  let myInvoices = await callToAPI(`${config.apiUrl}/cartera/recibos-pendientes/`, 'get', {});
  return myInvoices
}


function getPoliciesTable(myPoliciesList) {
  let tableOfPolicies = []
  myPoliciesList.forEach(policy => {
      let rowVariant = 'success'
      if (policy.fecha_ultimo_cobro) rowVariant = ''
      let element = {
        isActive: true,
        id: policy.id,
        numero_poliza: policy.numero_poliza,
        cliente: policy.cliente,
        compania: policy.compania,
        ramo: policy.ramo,
        fecha_efecto: policy.fecha_efecto,
        mes_vencimiento: policy.mes_vencimiento,
        prima_total: policy.prima_total,
        fecha_ultimo_cobro: policy.fecha_ultimo_cobro,
        _rowVariant: rowVariant
      }
    tableOfPolicies.push(element);
    }
  )
  return tableOfPolicies
}

function getInvoicesOfPoliciesTable(myInvoicesList) {
  let tableOfInvoices = []
  myInvoicesList.forEach(invoice => {
      let rowVariant = 'success'
      if (invoice.fecha_cobro == 'No cobrado') rowVariant = ''
      else if (invoice.fecha_liquidacion == 'No liquidado') rowVariant = 'warning'
      let element = {
        isActive: true,
        erp_id: invoice.erp_id,
        numero_recibo: invoice.numero_recibo,
        serie: invoice.serie,
        poliza_id: invoice.poliza_id,
        numero_poliza: invoice.numero_poliza,
        compania: invoice.compania,
        cliente: invoice.cliente,
        nif: invoice.nif,
        fecha_cobro: invoice.fecha_cobro,
        fecha_liquidacion: invoice.fecha_liquidacion,
        fecha_efecto: invoice.fecha_efecto,
        fecha_baja: invoice.fecha_baja,
        importe: invoice.importe + '€',
        _rowVariant: rowVariant
      }
    tableOfInvoices.push(element);
    }
  )
  return tableOfInvoices
}
